import React from 'react';
import styled from '@emotion/styled';

export default function Button({
    children,
    onClick,
    disabled,
    className,
    fillType = 'fill',
    radius = 16,
    height = 56,
    style,
}: {
    children: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
    className?: string;
    fillType?: 'fill' | 'outline';
    radius?: number;
    height?: number;
    style?: React.CSSProperties;
}) {
    return (
        <ButtonStyled
            type='button'
            onClick={onClick}
            disabled={disabled}
            className={className}
            fill={fillType}
            radius={radius}
            height={height}
            style={style}
        >
            {children}
        </ButtonStyled>
    );
}

const ButtonStyled = styled.button<{fill: 'fill' | 'outline'; radius: number; height: number}>`
    width: 100%;
    height: ${({height}) => height}px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${({radius}) => radius}px;
    background-color: ${({fill}) => (fill === 'fill' ? '#0e6736' : 'transparent')};
    color: ${({fill}) => (fill === 'fill' ? '#fff' : '#222')};
    border: ${({fill}) => (fill === 'fill' ? 'none' : '1px solid #E6E6E6')};
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;

    &:disabled {
        background-color: #f2f3f4;
        color: #ccc;
    }
`;
